import React, { memo, useEffect } from 'react';
import { UrlUtils } from 'src/utils';
import { ContentUI } from './content';
import { NetWorkUI } from './network';
import { ConsentCookies } from 'src/modules/shared/components/Consent';
import { useBoolean } from 'react-use';

interface IProps {
    page: string;
}

export function ContainerUI({ page }: IProps) {
    const [isReadyZA, setIsReadyZA] = useBoolean(false);

    useEffect(() => {
        if (typeof (window as any).ZA === 'undefined') {
            document.addEventListener('ZA.onready', () => {
                setIsReadyZA(true);
            });
        } else {
            setIsReadyZA(true);
        }
        return () => {
            document.removeEventListener('ZA.onready', () => setIsReadyZA(true));
        };
    }, []);

    return (
        <>
            {!UrlUtils.isContentDetailPage(page) && <ContentUI />}
            <NetWorkUI />
            {isReadyZA && <ConsentCookies />}
        </>
    );
}

export default memo(ContainerUI);
